// extracted by mini-css-extract-plugin
export default {"image":"L5u5gG"};